export const APP_CONFIGURATION_KEYS = {
  applicationInsightConnectionstring: 'ApplicationInsights:ConnectionString'
};
